<script>
  import GallerySlider from "./GallerySlider.svelte";
  import Image from "$lib/Image.svelte";
  export let block;

  let active = -1;

  const getImage = (image) => {
    const portrait = Object.fromEntries(
      Object.entries(image)
        .filter(([key]) => key.indexOf("portrait-") === 0)
        .map(([key, value]) => [key.replace("portrait-", ""), value]),
    );
    return {
      ...portrait,
      ...portrait.main,
    };
  };

  $: slides = block.slides.map((slide) => ({
    ...slide,
    image: slide.image_alt || getImage(slide.image),
  }));
</script>

<div class="flex flex-wrap">
  {#each block.slides as slide, index}
    <div
      class="w-full md:w-1/2 relative overflow-hidden group cursor-pointer"
      on:click={() => (active = index)}
    >
      <Image
        image={slide.image}
        class="transition transform group-hover:scale-110 duration-300"
      />
      <div
        class="font-display absolute opacity-0 group-hover:opacity-100 flex items-center justify-center inset-0 backdrop-filter backdrop-blur-sm transition duration-300 text-white p-4 text-center font-extrabold text-6xl uppercase"
      >
        {slide.hover_text}
      </div>
    </div>
  {/each}
</div>
<GallerySlider bind:active {slides} />
